enum BuildFlag { Dev = 'dev', Prod = 'prod', Italy = 'itely' }

declare var require: any;
const CONFIG = require('../config.json');
const BUILD_FLAG: BuildFlag = BuildFlag.Prod;
export const environment = CONFIG[BUILD_FLAG];
